export default "__VITE_ASSET__DWCAIWfQ__"